import React from 'react';
import {
  Button,
  CustomInput,
  FormGroup,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Spinner,
} from 'reactstrap';

const renderResolvedDateRange = ({ from, to, isDefaultApplied }) => {
  const qualifier = isDefaultApplied
    ? ' Dates the search filters do not set were applied by default.'
    : '';
  return (
    <div className="mt-3">
      {`The export will cover ${from} to ${to} in UTC.${qualifier}`}
    </div>
  );
};

const renderProducts = (props) => {
  if (!props.products.length) return null;
  return (
    <FormGroup tag="fieldset" className="mt-3">
      <legend className="col-form-label p-0">Products</legend>
      { props.products.map((code) => (
        <CustomInput
          key={code}
          id={`export-csv-product-${code}`}
          type="checkbox"
          label={code}
          checked={props.selectedProducts.includes(code)}
          // Locked while an export runs: the payload was captured at submit, so a later toggle
          // would leave the boxes describing something other than the file being downloaded.
          disabled={props.isExporting}
          onChange={() => props.onProductToggle(code)}
        />
      ))}
    </FormGroup>
  );
};

export default function ExportCSVModalView(props) {
  const hasEmptySelection = props.products.length > 0 && props.selectedProducts.length === 0;
  return (
    <Modal isOpen>
      <ModalHeader>Export Request History to CSV</ModalHeader>
      <ModalBody>
        <div>
          Use the current search filters to generate a CSV export of the scoring request history.
          Exports are limited to 100,000 records and larger exports can take several minutes to complete.
          The CSV file will automatically download once ready.
        </div>
        {
          renderResolvedDateRange(props.dateRange)
        }
        {
          renderProducts(props)
        }
        {
          hasEmptySelection && (
            <div className="mt-3 text-danger">
              Select at least one product to export.
            </div>
          )
        }
        {
          props.isExporting && !props.exportResult && (
            <div className="mt-3">
              The CSV is being generated. Please keep this window open until it completes.
            </div>
          )
        }
        {
          props.exportResult?.error && (
            <div className="mt-3 text-danger">
              {props.exportResult.error}
            </div>
          )
        }
        {
          props.exportResult?.success && (
            <>
              <div className="mt-3 text-success">
                The CSV was successfully generated.
              </div>
              <div className="mt-3">
                If the file did not automatically download, you can
                <a href={props.exportResult.url}>click here</a>
                to download it.
              </div>
            </>
          )
        }
      </ModalBody>
      <ModalFooter>
        <Button
          color="primary"
          onClick={props.onSubmit}
          disabled={props.isExporting || props.exportResult?.success || hasEmptySelection}
        >
          { props.isExporting ? <Spinner size="sm" color="white" /> : 'Export CSV' }
        </Button>
        {' '}
        <Button color="secondary" onClick={props.onClose} disabled={props.isExporting}>
          { props.exportResult ? 'Close' : 'Cancel'}
        </Button>
      </ModalFooter>
    </Modal>
  );
}
